'use client';

import { GitCompare, X, Trash2 } from 'lucide-react';
import { useCompare, COMPARE_MAX } from './CompareContext';

export default function CompareBar() {
  const { selected, remove, clear, openModal } = useCompare();
  if (selected.length === 0) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 pointer-events-none">
      <div className="max-w-7xl mx-auto px-4 pb-4">
        <div className="pointer-events-auto bg-white shadow-2xl border border-slate-200 rounded-2xl p-3 flex items-center gap-3 flex-wrap">
          <div className="flex items-center gap-2 px-2">
            <GitCompare className="w-5 h-5 text-blue-600" />
            <span className="text-sm font-bold text-slate-900">
              Confronto ({selected.length}/{COMPARE_MAX})
            </span>
          </div>

          <div className="flex items-center gap-2 flex-1 min-w-0 overflow-x-auto">
            {selected.map((b) => (
              <div
                key={b.id}
                className="flex items-center gap-2 bg-slate-50 border border-slate-200 rounded-xl pl-2 pr-1 py-1 shrink-0"
              >
                {b.image ? (
                  // eslint-disable-next-line @next/next/no-img-element
                  <img src={b.image} alt={b.name} className="w-8 h-8 rounded-lg object-cover" />
                ) : (
                  <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-sky-300 to-blue-500" />
                )}
                <span className="text-xs font-semibold text-slate-700 max-w-[120px] truncate">{b.name}</span>
                <button
                  type="button"
                  onClick={() => remove(b.id)}
                  className="w-6 h-6 rounded-md hover:bg-slate-200 flex items-center justify-center text-slate-500 hover:text-slate-800"
                  aria-label="Rimuovi dal confronto"
                >
                  <X className="w-3.5 h-3.5" />
                </button>
              </div>
            ))}
          </div>

          <button
            type="button"
            onClick={clear}
            className="text-xs font-semibold text-slate-500 hover:text-red-600 flex items-center gap-1 px-2 py-1.5"
          >
            <Trash2 className="w-3.5 h-3.5" />
            Svuota
          </button>
          <button
            type="button"
            onClick={openModal}
            disabled={selected.length < 2}
            className="px-4 py-2 rounded-xl bg-blue-600 hover:bg-blue-700 disabled:bg-slate-300 disabled:cursor-not-allowed text-white text-sm font-bold"
          >
            Confronta
          </button>
        </div>
      </div>
    </div>
  );
}
